import DeviceConfig from '@devices/config';
import Direction from '../../../../../shared/types/enums/direction';
import FloatingMenuListContainer from '../../../atoms/container/floatingMenuListContainer';
import FloatingMenuButton from '../../../elements/buttons/floatingMenuButton';
import Focus from '../../../../../shared/types/enums/focus';
import MenuList from '../list';
import Routes from '@shared/types/enums/routes';
import useKeyboard from '../../../../../shared/components/utils/hooks/useKeyboard';
import useOutsideClick from '../../../../../shared/components/utils/hooks/useOutsideClick';
import { FloatingMenuUtils } from '@shared/utils/floatingMenu';
import { closeFloatingMenu } from '../../../../../shared/store/thunks/floatingMenu.thunk';
import { floatingMenuSelector } from '../../../../../shared/store/slices/floatingMenu.slice';
import { useState, useEffect, useRef } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../shared/store/hooks';
import {
  channelDown,
  channelUp,
} from '../../../../../shared/store/thunks/channels.thunk';

function FloatingMenuList() {
  const dispatch = useAppDispatch();
  const { asset, route, reload } = useAppSelector(floatingMenuSelector);
  const [buttons, setButtons] = useState(
    FloatingMenuUtils.getMenuButtons(asset, route)
  );
  const [focused, setFocused] = useState(
    !DeviceConfig.capabilities.repeatSelect
  );
  const [load, setLoad] = useState(false);

  const floatingContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setLoad(true);
  }, []);

  useEffect(() => {
    asset &&
      reload &&
      setButtons(FloatingMenuUtils.getMenuButtons(asset, route));
  }, [reload]);

  useKeyboard({
    focus: Focus.FLOATING_MENU,
    stopPropagation: true,
    keyDownHandler: (key) => {
      switch (key) {
        case 'CHANNEL_DOWN':
          dispatch(closeFloatingMenu());
          dispatch(channelDown());
          break;
        case 'CHANNEL_UP':
          dispatch(closeFloatingMenu());
          dispatch(channelUp());
          break;
      }
    },
    keyUpHandler: (key) => {
      switch (key) {
        case 'BACK':
        case 'LEFT':
          dispatch(closeFloatingMenu());
          break;
        case 'SELECT':
          DeviceConfig.capabilities.repeatSelect && setFocused(true);
      }
    },
    pointerUpHandler: () => {
      setFocused(true);
    },
  });

  useOutsideClick(floatingContainerRef.current, () => {
    dispatch(closeFloatingMenu());
  });

  return (
    <FloatingMenuListContainer
      load={load}
      ref={floatingContainerRef}
      disableBlur={route === Routes.PLAYER || route === Routes.ZAPPER}
    >
      {buttons && (
        <MenuList
          direction={Direction.VERTICAL}
          focus={Focus.FLOATING_MENU}
          optionalSelect={'RIGHT'}
        >
          {buttons.map((item, index) => {
            return (
              <FloatingMenuButton
                index={index}
                key={index}
                releaseAction={() =>
                  focused && item.action && item.action(asset || undefined)
                }
                clickAction={() => {
                  focused && item.action && item.action(asset || undefined);
                }}
                icon={item.icon}
                text={item.text}
              />
            );
          })}
        </MenuList>
      )}
    </FloatingMenuListContainer>
  );
}

export default FloatingMenuList;
